import React from 'react'
import { FormGroup, InputGroup } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import StockStore from 'stores/StockStore'
import CKAutocomplete from 'component/element/CKAutocomplete'
import SearchCarButton from 'component/element/SearchCarButton'

export default class SearchJob extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      show:false,
      car_registration_no_list:[],
      styleCarRegis:''
    }
  }

  componentDidMount() {

  }

  loadCarRegistrationNo() {
    let {styleCarRegis} = this.state
    let {value} = this.props
    let car = []
    StockStore.loadCarRegistrationNoWithWork(value,(result) => {
        styleCarRegis = ''
        result.data.forEach(element => {
          car.push({
            id: element.Value,
            label: element.Name,
            car_info: element.car_info,
            work_no: element.work_no,
            car_registration_no:element.car_registration_no
          })
        });
        this.setState({car_registration_no_list:car,styleCarRegis:styleCarRegis})
        if (result.data.length===0&&value!=='') {
          styleCarRegis = 'has-warning'
          if (this.props.onClearWorkNo!==undefined)
            this.props.onClearWorkNo()
          
          this.setState({styleCarRegis:styleCarRegis})
        }
    })
  }

  onTextChange(e) {
    if (this.props.onChange!==undefined) {
      let value = {target:{value:e.target.value}}
      this.props.onChange(value)
      this.loadCarRegistrationNo()
    }
  }

  onTextSelect(item,items) {
    if (this.props.onSelect!==undefined) {
      this.props.onSelect(items)
    }
  }

  onTextFocus() {
    this.loadCarRegistrationNo()
  }

  onCarSearchSelect(items) {
    if (this.props.onCarSearchSelect!==undefined) {
      this.props.onCarSearchSelect(items)
      this.loadCarRegistrationNo() 
    }
  }

  onFocus() {
    this.input.focus()
  }

  render() {
    let {value,isDisabled,inTable,workNo} = this.props
    return(
                <FormGroup className={this.state.styleCarRegis}>
                  <InputGroup>
                    <CKAutocomplete
                      ref={el => this.input = el}
                      disabled={isDisabled}
                      choiceStyle={{width:'350px'}}
                      items={this.state.car_registration_no_list}
                      value={value}
                      workNo={workNo}
                      onChange={this.onTextChange.bind(this)}
                      onSelect={this.onTextSelect.bind(this)}
                      onFocus={this.onTextFocus.bind(this)}
                      inTable={inTable}
                    />
                    <InputGroup.Addon style={{pointerEvents:(isDisabled?'none':'unset')}} disabled={isDisabled} className='btn' onClick={()=>this.setState({show:true})}>
                      <FontAwesome name='plus' />
                    </InputGroup.Addon>
                  </InputGroup>
                  <SearchCarButton
                    show={this.state.show}
                    onHide={()=>{this.setState({show:false})}}
                    onSelect={this.onCarSearchSelect.bind(this)}
                  />
                </FormGroup>
    )
  }
}

SearchJob.defaultProps = {
  value:null,
  isDisabled:false,
  inTable:true,
  workNo:''
}


// WEBPACK FOOTER //
// ./src/component/element/SearchJob.js